var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7768 4.22318C19.9838 4.43014 20.0539 4.73736 19.9572 5.01362L14.8905 19.4898C14.7873 19.7846 14.5146 19.9866 14.2025 19.9994C13.8903 20.0121 13.6021 19.833 13.4752 19.5475L10.699 13.301L4.45247 10.5248C4.167 10.3979 3.9879 10.1097 4.00064 9.79753C4.01337 9.48539 4.21536 9.21265 4.51021 9.10945L18.9864 4.0428C19.2626 3.94611 19.5699 4.01622 19.7768 4.22318ZM12.1849 12.8926L14.0871 17.1725L17.416 7.66149L12.1849 12.8926ZM16.3385 6.58399L6.82749 9.91285L11.1074 11.8151L16.3385 6.58399Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.70500898.svg";
export { ForwardRef as ReactComponent };